import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';

const initialState = {
  error: null,
  data: [],
  financeConfirmationData: [],
  addData: {},
};

const slice = createSlice({
  name: 'utilityBills',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getUtilityBillsSuccess(state, action) {
      state.data = action.payload.data;
    },

    getUtilityBillFinanceConfirmationSuccess(state, action) {
      state.financeConfirmationData = action.payload.data;
    },

    addOrUpdateUtilityBill(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },
  },
});

export default slice.reducer;

export function getUtilityBills(locationId) {
  return async () => {
    try {
      const response = await get(`utilityBills?locationId=${locationId || ''}`);
      if (response.status) {
        dispatch(slice.actions.getUtilityBillsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUtilityBillFinanceConfirmation(locationId) {
  return async () => {
    try {
      const response = await get(`utilityBillFinanceConfirmation?locationId=${locationId || ''}`);
      if (response.status) {
        dispatch(slice.actions.getUtilityBillFinanceConfirmationSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addUtilityBill(body) {
  return async () => {
    try {
      const response = await post('utilityBills', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityBill(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateUtilityBill(body) {
  return async () => {
    try {
      const response = await put('utilityBills', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityBill(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteUtilityBill(body) {
  return async () => {
    try {
      const response = await deleteMethod('utilityBills', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityBill(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function confirmUtilityBillFinance(body) {
  return async () => {
    try {
      const response = await put('confirmUtilityBillFinance', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityBill(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function rejectUtilityBillFinance(body) {
  return async () => {
    try {
      const response = await put('rejectUtilityBillFinance', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityBill(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
